exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divBox[data-v-065ce1a7]{padding-bottom:0;margin-bottom:10px}.card-box[data-v-065ce1a7]{height:calc(100vh - 130px);overflow-y:scroll}\n", ""]);

// exports
